import { functions } from "config/firebase/firebase";

export const makeOrderLost = async (orderId: string) => {
  const makeOrderLostFunc = functions.httpsCallable("makeOrderLost");
  await makeOrderLostFunc({ orderId: orderId });
};
